const searchBtn = document.getElementById('search-btn');
const searchBar = document.getElementById('search-bar');

if(searchBar && searchBtn) {
    searchBtn.addEventListener('click', () => {
      if(searchBar.classList.contains('open')) {
          searchBar.classList.remove('open');
          searchBtn.classList.remove('open');
      }  else {
          searchBar.classList.add('open');
          searchBtn.classList.add('open');
      }
    });
}